import { render, staticRenderFns } from "./MenuM.vue?vue&type=template&id=43913133&scoped=true"
import script from "./MenuM.vue?vue&type=script&lang=js"
export * from "./MenuM.vue?vue&type=script&lang=js"
import style0 from "./MenuM.vue?vue&type=style&index=0&id=43913133&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43913133",
  null
  
)

export default component.exports